// Project metadata + captions, sourced from WEB_DATA/*/CAPTIONS.docx.
// Image files live at /images/<slug>/{full,thumb}/<id>.jpg.

const img = (slug, id) => ({
  id,
  full: `/images/${slug}/full/${id}.jpg`,
  thumb: `/images/${slug}/thumb/${id}.jpg`,
});

const chandrodayCaptions = {
  1: "Formal Living Room Verandah, as seen from South-West",
  3: "Formal Living Verandah and Home Theater seen from Bedroom Passage; toe-wall of courtyard in background",
  4: "Formal Living Verandah seen from Bedroom Passage — none of the trees were cut during construction",
  7: "Building as seen from North-East; Pooja Room and terrace verandah of Lounge at first floor, kund surrounding the Pooja Room",
  8: "Kund surrounding Pooja Room as seen from East",
  9: "Family Living Room",
  10: "Family Living Room — note the entrance passage-vestibule",
  11: "Building and courtyard as seen from West, first floor",
  13: "Formal Living and courtyard as seen from South, first floor",
  15: "Courtyard as seen from Formal Living Verandah",
  16: "Courtyard as seen from Home Theater",
  17: "Formal Living Verandah as seen from West",
  18: "Courtyard as seen from North-West",
  19: "Library / Home Theater passage as seen from North",
  20: "Courtyard",
  21: "Courtyard as seen from North, first floor",
  22: "Building entrance as seen from North",
  24: "Building as seen from North, evening",
  25: "Formal Living Room",
  26: "Staircase — Indian Teak Wood with Rosewood inlay",
  27: "Passage from bedrooms, leading to Dining Room and Kitchen",
  28: "Bedroom on ground floor",
  29: "First floor bedroom passage, lounge beyond",
  32: "Mango orchard as seen from Bedroom Verandah, first floor",
  33: "Building ensemble — evening",
};

const chandrodayIds = [1, 3, 4, 7, 8, 9, 10, 11, 13, 15, 16, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27, 28, 29, 32, 33];

const veiledCaptions = {
  1: "Complete building ensemble, as seen from South-East — architectural wire mesh brings privacy to landscaped terraces outside first-floor bedrooms",
  3: "Complete building ensemble, as seen from South",
  7: "Tensile parking, front yard, lawn and gazebo as seen from entry",
  10: "Stair case leading to bedrooms from first floor; Namaz room behind",
  11: "Master Bedroom",
  12: "Master Bedroom",
  17: "Master Bedroom landscaped terrace",
  20: "Master Bedroom landscaped terrace — architectural wire mesh for privacy",
  21: "Son's Bedroom landscaped terrace — architectural wire mesh for privacy",
  23: "Complete building ensemble as seen from South-East, evening",
  24: "Complete building ensemble as seen from South, from the gazebo, evening",
  25: "Complete building ensemble as seen from South, evening",
  26: "Kund flanking the Formal Living Room, from the landscape, evening",
  27: "Formal Living Room element and kund as seen from the landscape, evening",
  28: "Complete building ensemble as seen from South, evening",
};

const veiledIds = [1, 3, 7, 10, 11, 12, 17, 20, 21, 23, 24, 25, 26, 27, 28];

export const projects = [
  {
    slug: "chandroday",
    title: "Chandroday",
    typology: "Residence",
    location: "Bhavnagar, Gujarat",
    year: "",
    summary:
      "A house built within a mango orchard, gathered around a central courtyard. Every mature tree on site was preserved — the plan threads itself between them. Indoor–outdoor transitions unfold through verandahs, a kund surrounding the pooja room, and a first-floor lounge opening to a semi-covered terrace.",
    cover: "7",
    heroId: "7",
    images: chandrodayIds.map((id) => ({
      ...img("chandroday", id),
      caption: chandrodayCaptions[id] || "",
    })),
  },
  {
    slug: "veiled-house",
    title: "The Veiled House",
    typology: "Residence",
    location: "Bhavnagar, Gujarat",
    year: "",
    summary:
      "A family house defined by an architectural wire-mesh veil — raised walls that still respond to human scale while screening the landscaped terraces of first-floor bedrooms. Formal living opens to a generous landscape and a reflective kund; private zones fold inward around a central stair.",
    cover: "25",
    heroId: "25",
    images: veiledIds.map((id) => ({
      ...img("veiled-house", id),
      caption: veiledCaptions[id] || "",
    })),
  },
];

export const getProject = (slug) => projects.find((p) => p.slug === slug);
